import React from 'react';
import ContactForm from '../ContactFrom/ContactForm';
import { useLanguage } from '../../i18n/LanguageContext';

const ContactArea = (props) => {
  const { t } = useLanguage();
  return (
    <section className={`wpo-contact-area section-padding ${props.contactclass || ''}`} id="contact">
      <div className="wpo-wpo-contact-form-map">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '56px' }}>
            <span className="section-label">{t.contact?.sectionLabel}</span>
            <h2 style={{ color: '#f1f5f9', fontSize: '36px', fontWeight: 800, margin: '0 0 12px' }}>
              {t.contact?.sectionTitle}
            </h2>
            <p style={{ color: '#475569', fontSize: '15px', maxWidth: '500px', margin: '0 auto' }}>
              {t.contact?.subtext}
            </p>
          </div>
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-12">
              <div className="row">
                <div className="col col-lg-6 col-md-12 col-12">
                  <div className="wpo-contact-form">
                    <ContactForm />
                  </div>
                </div>
                <div className="col col-lg-6 col-md-12 col-12">
                  <div className="wpo-contact-info">
                    <div className="info-item">
                      <h2>{t.contact?.location}</h2>
                      <div className="info-wrap">
                        <div className="info-icon">
                          <i className="fi flaticon-location"></i>
                        </div>
                        <div className="info-text">
                          <span>{t.contact?.locationLabel}</span>
                        </div>
                      </div>
                    </div>
                    <div className="info-item">
                      <h2>
                        <a href="mailto:Emmanuel-Merida@outlook.com">
                          {t.contact?.email}
                        </a>
                      </h2>
                      <div className="info-wrap">
                        <div className="info-icon">
                          <i className="fi flaticon-mail"></i>
                        </div>
                        <div className="info-text">
                          <a href="mailto:Emmanuel-Merida@outlook.com">
                            {t.contact?.emailLabel}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="info-item">
                      <h2>
                        <a
                          href="https://www.linkedin.com/in/emmanuel-m%C3%A9rida-toledo-8920b929a/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t.contact?.network}
                        </a>
                      </h2>
                      <div className="info-wrap">
                        <div className="info-icon">
                          <i className="fi flaticon-phone-call"></i>
                        </div>
                        <div className="info-text">
                          <a
                            href="https://www.linkedin.com/in/emmanuel-m%C3%A9rida-toledo-8920b929a/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t.contact?.networkLabel}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactArea;
